import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function UnderageDialog({
  open,
  onOpenChange,
  isAdultsOnly,
  onCancel,
  onSwitchToChild,
  onRedirectToPediatrics,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nepilnamečio registracija</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {!isAdultsOnly ? (
            <DialogDescription>
              Nepilnamečius registruoti turi tėvai ar globėjai ir vaiko
              informaciją pateikti lange pažymėjus „Registruoju vaiką iki 18
              metų“. Pereiti į vaiko registraciją?
            </DialogDescription>
          ) : (
            <DialogDescription>
              Nepilnamečius registruoti turi tėvai ar globėjai kategorijoje
              „Vaikų gydytojų specialistų konsultacijos“. Pereiti į šią
              kategoriją?
            </DialogDescription>
          )}
        </DialogBody>

        <DialogFooter className="sm:gap-2">
          <Button variant="outline" onClick={onCancel}>
            Atšaukti
          </Button>

          {!isAdultsOnly ? (
            <Button onClick={onSwitchToChild}>Tęsti</Button>
          ) : (
            <Button onClick={onRedirectToPediatrics}>Tęsti</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function ChildAgeRestrictionDialog({
  open,
  onOpenChange,
  isChildrenAgeRestrictionApplicable,
  childAgeFrom,
  childAgeTo,
  onClose,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Amžiaus apribojimas</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {isChildrenAgeRestrictionApplicable && childAgeFrom ? (
            <DialogDescription>
              Gydytojas konsultuoja tik vaikus nuo {childAgeFrom} iki ${childAgeTo ?? 18} metų.
            </DialogDescription>
          ) : (
            <DialogDescription>
              Gydytojas konsultuoja tik vaikus iki 18 metų.
            </DialogDescription>
          )}
        </DialogBody>
        <DialogFooter className="sm:gap-2">
          <Button variant="outline" onClick={onClose}>
            Gerai
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
